export enum FieldsCompleteEnum {
  motivation,
  intitule_poste,
  intitule_poste_autre,
  categorie,
  remuneration,
  dir_cmp,
  date_debut,
  date_fin,
  vacation, // vacation
  quotite, // ou quotité
  fiche_poste,
  fiche_financiere
}
